import type { PowerUpKind } from '../../shared/power-ups';
import type { PowerUpMessage } from '../../shared/protocol';
import { powerUpAnnouncement, powerUpFeedbackOutcome, type PowerUpFeedbackOutcome } from './chaos';

interface PickupCue {
  kind: PowerUpKind;
  outcome: PowerUpFeedbackOutcome;
  announcement: string;
  sequence: number;
}

/** Keep the static acknowledgement visible briefly even when motion is disabled. */
const PICKUP_CUE_MS = 1_000;

/** One replaceable board cue; independent of current-word feedback and round-owned by its component. */
export class PowerUpFeedback {
  cue = $state<PickupCue | null>(null);
  private sequence = 0;
  private timer: ReturnType<typeof setTimeout> | undefined;

  show(message: PowerUpMessage, meId: string, nameOf: (id: string) => string): void {
    const outcome = powerUpFeedbackOutcome(message, meId);
    if (!outcome) return;
    clearTimeout(this.timer);
    this.cue = {
      kind: outcome === 'blocked' ? 'shield' : message.kind,
      outcome,
      announcement: powerUpAnnouncement(message, meId, nameOf),
      sequence: ++this.sequence,
    };
    this.timer = setTimeout(() => (this.cue = null), PICKUP_CUE_MS);
  }

  dispose(): void {
    clearTimeout(this.timer);
    this.cue = null;
  }
}
